var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Quote"},on:{"on-hide":_vm.resetFormData}},[_c('quotes-form',_vm._b({key:_vm.formKey,attrs:{"is-dollar-general-fexa-quote":_vm.isDollarGeneralFexaQuote},on:{"on-submit":_vm.updateQuote,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'quotes-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }